class Carto {
    constructor(carto) {
        this.populateIframe(carto);
        this.removeFallback(carto);
        if (carto.title) {
            this.addElement(carto, carto.title, carto.cta, true);
        }
        if (carto.attribution) {
            this.addElement(carto, carto.attribution);
        }
        if (carto.legends) {
            const imgPlaceholder = document.getElementById(`carto-key-${carto.namespaceId}`);
            const img = this.createlegendElement(carto);
            const includeNumber = carto.namespaceId;

            /* eslint max-len: ["error", { "ignoreTemplateLiterals": true }] */
            imgPlaceholder.innerHTML = `<figure id='ns-responsive__figure' class='media-landscape' style='margin-right: auto; margin-left: auto; margin-top: 0;'>${img}</figure>`;
            imgPlaceholder.className += ` ns-responsive__key-${includeNumber}`;
        }
    }

    createlegendElement(carto) {
        const givenWidth = window.innerWidth || document.body.clientWidth;
        let lastBreakPoint = 0;
        let imgSrc = '';
        const breakpoints = this.getBreakpoints(carto.legends);
        let chosenBreakPoint;

        breakpoints.sort((a, b) => {
            return a - b;
        });

        Object.keys(breakpoints).forEach(i => {
            if (givenWidth > lastBreakPoint && givenWidth <= breakpoints[i]) {
                imgSrc = carto.legends[breakpoints[i]];
                chosenBreakPoint = breakpoints[i];
            }
            lastBreakPoint = breakpoints[i];
        });

        if (chosenBreakPoint === undefined) {
            imgSrc = carto.legends[lastBreakPoint];
            chosenBreakPoint = lastBreakPoint;
        }
        return `<img src='${imgSrc}' alt='${carto.alt}' />`;
    }

    getBreakpoints(obj) {
        const breakpoints = [];

        Object.keys(obj).forEach(k => {
            if (Object.prototype.hasOwnProperty.call(obj, k)) {
                breakpoints.push(parseInt(k, 10));
            }
        });

        return breakpoints;
    }

    hasQueryString(url) {
        return !!(/[?&][a-zA-Z0-9]+=*/.test(url));
    }

    populateIframe(carto) {
        const iframe = document.getElementById(`carto-frame-${carto.namespaceId}`);
        const qsChar = (this.hasQueryString(carto.iframe.source)) ? '&' : '?';
        iframe.height = carto.iframe.height;
        iframe.src = `${carto.iframe.source}${qsChar}cookies=0`;
    }

    removeFallback(carto) {
        const fallback = document.getElementById(`carto-fallback-${carto.namespaceId}`);
        document.getElementById(`carto-container-${carto.namespaceId}`).removeChild(fallback);
    }

    addElement(carto, textContent, subText, appendToTop) {
        const includeBody = document.getElementById(`carto-container-${carto.namespaceId}`);
        const content = document.createTextNode(textContent);

        if (appendToTop) {
            const h3 = document.createElement('h3');
            const sp = document.createElement('span');
            const cta = document.createTextNode(subText);

            h3.appendChild(content);
            sp.appendChild(cta);
            sp.className = 'carto-subhead';
            includeBody.insertBefore(sp, includeBody.firstChild);
            includeBody.insertBefore(h3, includeBody.firstChild);
        }
        else {
            const para = document.createElement('p');
            const italic = document.createElement('i');
            italic.appendChild(content);
            para.appendChild(italic);
            includeBody.appendChild(para);
        }
    }
}

new Carto({
    namespaceId: `${DEV_SCAFFOLD('name')}-${DEV_SCAFFOLD('includeName')}`,
    title: __('title'),
    cta: __('cta'),
    attribution: __('attribution'),
    iframe: {
        source: __('embed_url'),
        height: 450,
    },
    legends: {
        624: `${DEV_SCAFFOLD('assetsPath')}/${__('mobile_key')}`,
        976: `${DEV_SCAFFOLD('assetsPath')}/${__('desktop_key')}`,
    },
    alt: __('alt'),
});
